export const sxStyled = theme => ({
  root: {
    padding: '10px',
    maxWidth: '100%',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      padding: '20px',
      maxWidth: '1150px',
      width: '100%',
    },
  },

  firstText: {
    color: '#000000',
    marginTop: 0,
    fontWeight: 600,
    textAlign: 'center',
    marginBottom: '20px',
    fontSize: '16px',
    [theme.breakpoints.up('sm')]: {
      fontSize: '20px',
      marginBottom: '30px',
    },
  },

  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    justifyContent: 'center',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      gap: '0',
      justifyContent: 'center',
    },
  },

  closeIconContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },

  secondaryText: {
    color: '#000000',
    marginTop: 0,
    marginBottom: '15px',
    fontSize: '14px',
    [theme.breakpoints.up('sm')]: {
      marginBottom: '5px',
      fontSize: '20px',
    },
  },

  continueButton: {
    backgroundColor: '#FFFFFF',
    border: `1px solid ${theme.primary}`,
    borderRadius: '8px',
    fontWeight: 600,
    color: '#000000',
    width: '100%',
    fontSize: '16px',
    marginBottom: '10px',
    [theme.breakpoints.up('sm')]: {
      width: '300px',
      fontSize: '20px',
      marginBottom: 0,
    },
  },

  addButton: {
    backgroundColor: theme.primary,
    borderRadius: '8px',
    fontWeight: 600,
    color: theme.text1,
    width: '100%',
    fontSize: '14px',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)',
    [theme.breakpoints.up('sm')]: {
      width: '300px',
      fontSize: '18px',
    },
  },

  iconWarning: {
    color: '#F5A623',
    mb: 1,
    fontSize: '50px',
    [theme.breakpoints.up('sm')]: {
      fontSize: '80px',
    },
  },
});
